import { DataStore, Predicates, SortDirection } from '@aws-amplify/datastore';
import { isValidDate } from '@fullcalendar/react';
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Auth } from 'aws-amplify';
import moment from 'moment/moment';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import React, { Fragment, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import { reactLocalStorage } from 'reactjs-localstorage';
import Layout from "../../../components/common/nav/initiator/nav.component";
import { checkDuplicates, ConvertResponseForSelect, ConvertResponseForSelectWithRefCode, getResponseFromKey } from '../../../helper/commonfunctions';
import { Request_Status } from '../../../helper/enum';
import { ValidateApproverRole, ValidateInitiatorRole } from '../../../helper/validateRole';
import { AbsentCode, Employee, InitiateClassifiedWeeklyAbsenceReport, InitiateClassifiedWeeklyAbsenceReportEmployee, InitiateClassifiedWeeklyAbsenceReportEmployeeDetails, Schools } from '../../../models';
import Login from '../../../setup/auth/login.component';
import AWS from "aws-sdk";
import { USER_TYPES, USER_TYPES_NAMES, USER_TYPE_LABEL } from "../../../helper/enum";
import awsmobile from "../../../aws-exports";


export default function InitiateApproverReport() {

    const loggedUserId = reactLocalStorage.get('loggedUserId');
    const loggedL2Authority = reactLocalStorage.get('loggedl2authority');
    const loggedl1authority = reactLocalStorage.get('loggedl1authority');
    const loggedl2authority = reactLocalStorage.get('loggedl2authority');
    const { reportId } = useParams();
    const [periodDates, setPeriodDates] = useState([]);
    const [schoolList, setSchoolList] = useState([]);
    const [absentCodeList, setAbsentCodeList] = useState([]);
    const [absentCodeListDropdown, setAbsentCodeListDropdown] = useState([]);
    const [selectedSchool, setSelectedSchool] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [absentCode, setAbsentCode] = useState([]);
    const [isAuthenticated, userHasAuthenticated] = useState(true);
    const [absentDate, setAbsentDate] = useState([]);
    const [visible, setVisible] = useState(false);
    const [employeeList, setEmployeeList] = useState();
    const [updatedEmpList, setUpdatedEmpList] = useState();
    const [allEmployeeList, setAllEmployee] = useState();
    const [showPleaseWaitButton, setPleaseWaitButton] = useState(false);
    const [disabled, setDisabled] = useState(false);
    let navigateTo = useNavigate();
    const [visibleSumbit, setVisibleSumbit] = useState(false);
    const [visibleDialogue, setVisibleDialogue] = useState(false);
    const [mappedData, setMappedData] = useState([]);
    const [selectedDateRecord, setSelectedDateRecord] = useState([]);
    const [maxDate, setMaxDate] = useState(null);
    const [minDate, setMinDate] = useState(null);
    const [dateCount, setDateCount] = useState(0);
    const [isShowSelectedDate, setIsShowSelectedDate] = useState(false);
    const [SelectperiodExpand, setActivate] = useState("");
    const [selectApprover, SetSelectApprover] = useState()
    const [allUserList, setAllUsersList] = useState([]);
    const [SPUsersWithoutAdmin, setSPUsersWithoutAdmin] = useState([]);
    const [users, SetUsersList] = useState([]);
    const [payrollUser, setPayrollUserList] = useState([]);
    const [l1UserList, Setl1UserList] = useState([]);
    const [disabledDates, setDisabledDates] = useState([]);


    //SET AWS Configuration
    AWS.config.update({
        accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
        secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
        region: process.env.REACT_APP_AWS_Region,
    });


    const toggleActiveexpand = () => { setActivate(SelectperiodExpand === "SelectperiodExpand" ? "" : "SelectperiodExpand") };

    async function onLoad() {
        try {
            await Auth.currentSession();
            if (!ValidateApproverRole()) { userHasAuthenticated(false); }
        } catch (e) {
            userHasAuthenticated(false);
        }
    }

    //*onClick Select Period
    const onClickDates = (date) => {
        setSelectedDateRecord([]);
        setIsShowSelectedDate(true)
        let newResponse = [];
        for (let i = 0; i < date.length; i++) {
            let data = { "employeeName": selectedEmployee.name, "selectedDate": date[i], "displayDate": date[i], "absentCode": { "name": "", "code": "" }, "absentId": "", "nameOfTheSubstitute": '', "hour": '', "minute": '' }
            newResponse.push(data)
            if (i === date.length - 1) {
                setSelectedDateRecord(newResponse)
            }
        }
    };


    //*onClick Select Period
    const onClickAbsentCode = (index, event) => {
        let absentCode = event.target.value
        let data = [...selectedDateRecord];
        data[index]["absentCode"] = absentCode;
        data[index]["absentId"] = absentCode.code;
        setSelectedDateRecord(data)
    };

    //*onClick Select Period
    const onClickNameOfSubstitute = (index, event) => {
        let nameOfTheSubstitute = event.target.value
        let data = [...selectedDateRecord];
        data[index]["nameOfTheSubstitute"] = nameOfTheSubstitute;
        data[index]["nameOfTheSubstituteId"] = absentCode.code;
        setSelectedDateRecord(data)
    };

    //*onClick Houre
    const onClickHoure = (index, value) => {
        let data = [...selectedDateRecord];
        data[index]["hour"] = value;
        setSelectedDateRecord(data)
    };

    //*onClick Min
    const onClickMin = (index, value) => {
        let data = [...selectedDateRecord];
        data[index]["minute"] = value;
        setSelectedDateRecord(data)
    };

    //onclick remove container details
    const onClickRemove = (index, detailIndex, detail) => {
        let data = [...mappedData];
        //set disabledates
        var indexofdate = disabledDates.indexOf(detail.selectedDate);
        let newDates = disabledDates.splice(indexofdate);
        setDisabledDates(disabledDates.filter(item => item !== detail.selectedDate))

        if (data[index].employeeResponse.length === 1) {
            data.splice(index, 1)
            setMappedData(data)
        } else {
            data[index].employeeResponse.splice(detailIndex, 1)
            setMappedData(data)
        }


    }

    async function LoadUsers() {

        try {
            const cognito = new AWS.CognitoIdentityServiceProvider();

            var params =
            {
                UserPoolId: awsmobile.aws_user_pools_id,
                Limit: 60
            };

            ///fetch users
            try {
                const data = await cognito.listUsers(params).promise();

                var newRes = []
                let userRole = '', userName = '', userEmail = '', userCode = '',sub='';
                data.Users.forEach((user, i) => {
                    userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                    userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
                    userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
                    userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
                    sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                    let obj = {
                        "userId": sub,
                        "name": userName,
                        "email": userEmail,
                        "usercode": userCode,
                        "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
                    }
                    newRes.push(obj);
                }
                );

                let usersWithoutAdmin = [];
                newRes.map((currentItem) => {
                    if (currentItem.role !== 'Admin') {
                        usersWithoutAdmin.push(currentItem);
                    }
                })
                setSPUsersWithoutAdmin(usersWithoutAdmin);

            } catch (err) {
                console.log(err);
            }
            //-------------

            cognito.listUsers(params, (err, data) => {
                if (err) {
                    console.log(err);
                    toast.error(err.message);
                } else {

                    const roles = [];
                    var newRes = []
                    var role = "";
                    var sub = "";
                    var name = "";
                    var email = "";
                    var usercode = "";
                    let withoutAdminUsers = [];
                    let payrollUser = []

                    data.Users.forEach((user, i) => {
                        role = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                        name = user.Attributes.find(attr => attr.Name === "name")?.Value;
                        email = user.Attributes.find(attr => attr.Name === "email")?.Value;
                        usercode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
                        sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                        let newUser = {
                            "userId": sub,
                            "name": name,
                            "email": email,
                            "usercode": usercode,
                            "role": role === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : role === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : role === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
                        }
                        newRes.push(newUser);

                        if (i === data.Users.length - 1) {

                            for (let i = 0; i < newRes.length; i++) {
                                const user = newRes[i];
                                const roleIndex = roles.findIndex(role => role.role === user.role);


                                if (roleIndex === -1) {
                                    roles.push({ role: user.role, count: 1, users: [user], email: user.email, name: user.name, usercode: user.usercode });
                                } else {
                                    roles[roleIndex].count++;
                                    roles[roleIndex].users.push(user);
                                }
                            }
                        }

                        if (role === USER_TYPES.APPROVER) {
                            let userObj = {
                                "userId": sub,
                                "name": name,
                                "email": email,
                                "usercode": usercode,
                                "role": role
                            }
                            withoutAdminUsers.push(userObj);
                        }

                        if (role === USER_TYPES.PAYROLL) {
                            let userObjs = {
                                "userId": sub,
                                "name": name,
                                "email": email,
                                "usercode": usercode,
                                "role": role
                            }
                            payrollUser.push(userObjs);
                        }
                    });

                    let sortArray = newRes.sort((a, b) => (a.name > b.name ? 1 : -1))


                    var userList = sortArray.map((currentItem) => {
                        return (
                            { code: currentItem.userId, name: currentItem.name }
                        )
                    })
                    const matchedItem = newRes.find(item => item.userId === loggedl2authority);
                    SetSelectApprover({ name: matchedItem.name, code: matchedItem.userId })
                    setAllUsersList(userList)
                    SetUsersList(roles);
                    setPayrollUserList(payrollUser);
                    Setl1UserList(withoutAdminUsers);

                }
            });

        } catch (e) {
            toast.error(e.message);
        }

    }

    const currentDateTime = moment();

    async function EmployeeList(e) {
        let schoolId = e.value.code;
        setSelectedSchool(e.value)
        try {
            var employeeResponses = await DataStore.query(Employee,
                (c) => c.school_id.eq(schoolId),
                { sort: s => s.employee_name(SortDirection.ASCENDING) }
            );
            if (employeeResponses !== null) {
                let employeeData = employeeResponses;

                let employee = [];
                employeeData.map((item) => {
                    let obj = {
                        name: (item.employee_name + ' ' + '(' + item.employee_code + ')'),
                        code: item.id
                    }
                    employee.push(obj);
                })

                setEmployeeList(employee);
            }
        }
        catch (error) {
            // console.log(error);
        }

    }


    async function BindList() {
        var employeeList = await DataStore.query(Employee, Predicates.ALL)

        setAllEmployee(employeeList)

        var SchoolResponses = await DataStore.query(Schools, Predicates.ALL, {
            sort: s => s.name(SortDirection.ASCENDING)
        });
        var schoolArray = []; schoolArray = ConvertResponseForSelect(SchoolResponses); setSchoolList(schoolArray);

        var AbsentCodeResponses = await DataStore.query(AbsentCode, Predicates.ALL, {
            sort: s => s.name(SortDirection.ASCENDING)
        });
        setAbsentCodeList(AbsentCodeResponses)
        var myArray = []; myArray = ConvertResponseForSelectWithRefCode(AbsentCodeResponses); setAbsentCodeListDropdown(myArray);

        if (reportId) {
            getData()
        }
    }

    //*get Existing Data
    const getData = async () => {
        if (reportId) {
            setVisible(true)
            setDisabled(true);
            let updateData = []
            var getAbsenceReport = await DataStore.query(InitiateClassifiedWeeklyAbsenceReport, reportId)
            let to_date = new Date(moment(getAbsenceReport.to_date).format("YYYY-MM-DD")); let from_date = new Date(moment(getAbsenceReport.from_date).format("YYYY-MM-DD"));
            let dateArray = [from_date, to_date]; setPeriodDates(dateArray);
            var getAbsenceReportOfEmployee = await DataStore.query(Schools, (c) => c.id.eq(getAbsenceReport.school_id))
            setSelectedSchool({ name: getAbsenceReportOfEmployee[0].name, code: getAbsenceReportOfEmployee[0].id })
            var employeeResponses = await DataStore.query(Employee,
                (c) => c.school_id.eq(getAbsenceReport.school_id),
                Predicates.ALL, { sort: s => s.employee_name(SortDirection.ASCENDING) }
            );
            if (employeeResponses !== null) {
                let employeeData = employeeResponses;
                let employee = [];
                employeeData.map((item) => {
                    let obj = {
                        name: (item.employee_name + ' ' + '(' + item.employee_code + ')'),
                        code: item.id
                    }
                    employee.push(obj);
                })
                setEmployeeList(employee);
            }
            if (getAbsenceReport) {
                var getAbsenceReportOfEmployee = await DataStore.query(InitiateClassifiedWeeklyAbsenceReportEmployee, (c) => c.initiate_classified_weekly_absence_report_id.eq(getAbsenceReport.id))
                let newResponse = [];
                for (var i = 0; i < getAbsenceReportOfEmployee.length; i++) {

                    let employeeResponse = await getEmployeeDetails(getAbsenceReportOfEmployee[i].id, getAbsenceReportOfEmployee[i].employee_id);
                    let empName = await DataStore.query(Employee, (c) => c.id.eq(getAbsenceReportOfEmployee[i].employee_id));
                    let data = {
                        "employeeName": empName[0].employee_name,
                        "employeeId": getAbsenceReportOfEmployee[i].employee_id,
                        "employeeResponse": employeeResponse
                    }

                    if (newResponse.length > 0) {
                        newResponse = [...newResponse, data];
                    } else {
                        newResponse.push(data)
                    }

                    if (i === getAbsenceReportOfEmployee.length - 1) {
                        setMappedData(newResponse)
                        setVisible(true);
                    }
                }
            }
        }
    }

    //*All state clear
    const getEmployeeDetails = async (employeeDetailId, employeeId) => {
        let newResponse = [];
        var getAbsenceReportOfEmployeeDetails = await DataStore.query(InitiateClassifiedWeeklyAbsenceReportEmployeeDetails, (c) => c.initiate_classified_weekly_absence_report_employee_id.eq(employeeDetailId))

        for (var i = 0; i < getAbsenceReportOfEmployeeDetails.length; i++) {

            let employeeName = ""; let substituteEmployeeName = "";
            let empResponse = await DataStore.query(Employee, (c) => c.id.eq(employeeId));
            if (empResponse.length > 0) { employeeName = empResponse[0].employee_name } else { employeeName = "" }
            let substituteResponse = await DataStore.query(Employee, (c) => c.id.eq(getAbsenceReportOfEmployeeDetails[i].substitute_emp_id))
            if (substituteResponse.length > 0) { substituteEmployeeName = substituteResponse[0].employee_name; } else { substituteResponse = ""; }
            var getAbsentCodeDetails = await DataStore.query(AbsentCode, (c) => c.id.eq(getAbsenceReportOfEmployeeDetails[i].absent_code_id))
            let getAbsentCodeObj;
            if (getAbsentCodeDetails.length > 0) { getAbsentCodeObj = { "name": getAbsentCodeDetails[0].name + " (" + getAbsentCodeDetails[0].code + ")", "code": getAbsentCodeDetails[0].id } } else { getAbsentCodeObj = { "name": "", "code": "" } }

            newResponse.push({
                "employeeName": employeeName, "selectedDate": getAbsenceReportOfEmployeeDetails[i].absent_date, "displayDate": getAbsenceReportOfEmployeeDetails[i].absent_date, "absentCode": getAbsentCodeObj, "absentId": getAbsenceReportOfEmployeeDetails[i].absent_code_id,
                "nameOfTheSubstitute": { "name": substituteEmployeeName, "code": getAbsenceReportOfEmployeeDetails[i].substitute_emp_id }, "nameOfTheSubstituteId": getAbsenceReportOfEmployeeDetails[i].substitute_emp_id, "hour": getAbsenceReportOfEmployeeDetails[i].partial_hour, "minute": getAbsenceReportOfEmployeeDetails[i].partial_min,
            })

            if (i === getAbsenceReportOfEmployeeDetails.length - 1) {
                return newResponse
            }
        }
    };

    //All state clear
    const stateClear = () => {

        setAbsentDate([])
    };

    //Create  Initiate New Report
    const applyReport = async () => {
        setDisabled(true)
        if (selectedSchool !== null && selectedEmployee !== null && periodDates.length > 0 && selectedDateRecord[0].hour !== null) {
            //*set data to table
            if (mappedData.length > 0) {
                let data = selectedDateRecord
                let getEmployeeNames = data.map((item) => item.employeeName)
                let removeDuplicateArray = checkDuplicates(getEmployeeNames)
                const getResponse = await getResponseFromKey(data, removeDuplicateArray, selectedEmployee.code);
                let object = getResponse[0];
                let myArray = [...mappedData, object];
                setMappedData(myArray);
                setSelectedDateRecord([]);
            } else {
                let data = selectedDateRecord
                let getEmployeeNames = data.map((item) => item.employeeName)
                let removeDuplicateArray = checkDuplicates(getEmployeeNames)
                const getResponse = await getResponseFromKey(data, removeDuplicateArray, selectedEmployee.code)
                setMappedData(getResponse);
                setSelectedDateRecord([]);
            }

            //disable date 
            let datesArray = []
            for (let i = 0; i < selectedDateRecord.length; i++) {
                datesArray[i] = selectedDateRecord[i].selectedDate
            }
            //let date
            let updatedList = [...disabledDates, ...datesArray]
            setDisabledDates(updatedList)


            setVisible(true);
            stateClear()
        } else {
            toast.error("Select mandatory fields.")
            if (reportId) { setVisible(true); } else { setVisible(false); }
        }

    }

    const goBack = () => {
        navigateTo("/approver/weekly_absence_report");
    }

    //*save Report
    const saveReport = async (status) => {
        setPleaseWaitButton(false);
        if (reportId) {
            // debugger;
            await DataStore.delete(InitiateClassifiedWeeklyAbsenceReport, (c) => c.id.eq(reportId)).then(async (response) => {
                await DataStore.delete(InitiateClassifiedWeeklyAbsenceReportEmployee, (c) => c.initiate_classified_weekly_absence_report_id.eq(reportId)).then(async (response) => {
                    await DataStore.delete(InitiateClassifiedWeeklyAbsenceReportEmployeeDetails, (c) => c.initiate_classified_weekly_absence_report_employee_id.eq(response.id)).then(async (response) => {
                        CommenFunction(status)
                    })
                })
            })
        } else {
            // debugger;
            CommenFunction(status)
        }
    }

    const CommenFunction = async (status) => {

        // save ALL data to datastore
        var newInitiateClassifiedWeeklyAbsenceReportId;
        var InitiateClassifiedWeeklyAbsenceReportId = await DataStore.save(
            new InitiateClassifiedWeeklyAbsenceReport({
                "user_id": loggedUserId,
                "from_date": moment(periodDates[0]).format("YYYY-MM-DD"),
                "to_date": moment(periodDates[1]).format("YYYY-MM-DD"),
                "status": status,
                "approver_status": Request_Status.AP,
                "approver_by": loggedUserId,
                "l2_authority": selectApprover.code,
                "l1_authority": loggedUserId,
                "approver_date_time": moment(currentDateTime).toISOString(),
                "school_id": selectedSchool.code,
                "status_date_time": moment(currentDateTime).toISOString()
            })
        );
        newInitiateClassifiedWeeklyAbsenceReportId = InitiateClassifiedWeeklyAbsenceReportId.id;

        if (newInitiateClassifiedWeeklyAbsenceReportId) {

            for (var i = 0; i < mappedData.length; i++) {

                //Save InitiateClassifiedWeeklyAbsenceReportEmployee
                var initiateClassifiedWeeklyAbsenceReportEmployee = await DataStore.save(
                    new InitiateClassifiedWeeklyAbsenceReportEmployee({
                        "initiate_classified_weekly_absence_report_id": newInitiateClassifiedWeeklyAbsenceReportId,
                        "employee_id": mappedData[i].employeeId,
                    })
                ).then(async (data) => {
                    saveEmployeeDetails(data.id, mappedData[i].employeeResponse)
                })

                if (i === mappedData.length - 1) {
                    toast.success('Data Added Successfully.');
                    { goBack() }
                }
            }
        }
    }

    //*Save Employee Details
    const saveEmployeeDetails = async (initiateClassifiedWeeklyAbsenceReportEmployeeId, employeeDetailsData) => {

        if (employeeDetailsData.length > 0) {
            for (let i = 0; i < employeeDetailsData.length; i++) {
                await DataStore.save(
                    new InitiateClassifiedWeeklyAbsenceReportEmployeeDetails({
                        "initiate_classified_weekly_absence_report_employee_id": initiateClassifiedWeeklyAbsenceReportEmployeeId,
                        "absent_code_id": employeeDetailsData[i].absentCode.code,
                        "substitute_emp_id": employeeDetailsData[i].nameOfTheSubstitute.code,
                        "is_full_day": false,
                        "partial_hour": employeeDetailsData[i].hour,
                        "partial_min": employeeDetailsData[i].minute,
                        "absent_date": moment(employeeDetailsData[i].selectedDate,).format("YYYY-MM-DD")
                    })
                );
            }
        }
    }

    const CalendarValidation = () => {
        toast.error("Please select Employee.")
    }

    const onSetEmployee = (e) => {
        console.log("employeeListemployeeList:-", employeeList)
        setSelectedEmployee(e.value);
        setDateCount(0);

        //create new list without selected employee
        let newEmpList = [];
        employeeList.map((currentItem) => {
            if (currentItem.code !== e.value.code) {
                newEmpList.push(currentItem);
            }
        })
        setUpdatedEmpList(newEmpList);
    }


    useEffect(() => {
        onLoad();
        BindList();
        setVisibleDialogue(false);
        LoadUsers()

    }, []);


    return isAuthenticated ? (
        <>
            <Layout pageTitle="Homepage" activeMenu="Initiator" appId={"WEEKLY_ABSENCE_REPORT"}>
                <div className="">
                    <div className="pt-24 md:pt-28 xl:pt-[2.083vw]">
                        <div className="">

                            <div className="text-[#113699] font-semibold -tracking-[0.02em] text-xl xl:text-[1.042vw]">
                                <h3>Initiate New Report</h3>
                            </div>
                            <div className="mt-5 xl:mt-[1.250vw]">
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[0.833vw] cust-select">
                                    {/*------School or Departament-----*/}

                                    <div className="w-full">
                                        <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Name of School or Department <span className='text-[red] pl-0.2'>*</span></label>
                                        <div className="relative">
                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                            <Dropdown id="dept" value={selectedSchool}
                                                onChange={(e) => {
                                                    EmployeeList(e)
                                                    setDateCount(0);
                                                }}
                                                filter
                                                disabled={disabled}
                                                options={schoolList} optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                            />
                                        </div>
                                    </div>

                                    {/*------School or Departament-----*/}
                                    <div className="w-full">
                                        <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Name of the Employee <span className='text-[red] pl-0.2'>*</span></label>
                                        <div className="relative">
                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                            <Dropdown id="employee" value={selectedEmployee}
                                                filter
                                                onChange={(e) => { onSetEmployee(e); setSelectedDateRecord([]); setAbsentDate([]) }} options={employeeList} optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                        </div>
                                    </div>



                                    <div className="w-full">
                                        <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Name of the Payroll<span className='text-[red] pl-0.2'>*</span></label>
                                        <div className="relative">
                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                            <Dropdown id="employee"
                                                value={selectApprover}
                                                onChange={(e) => { SetSelectApprover(e.value) }}
                                                options={allUserList}
                                                filter
                                                optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                        </div>
                                    </div>

                                    {/*-----Period----*/}
                                    <div className="w-full">
                                        <div className="">
                                            <label htmlFor="username" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Period <span className='text-[red] pl-0.2'>*</span></label> </div>
                                        <div className="w-full">
                                            <div className="relative custp-calender">
                                                <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                                <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                                                <div className="card justify-content-center">
                                                    {selectedEmployee === null && !reportId ?
                                                        <div onClick={() => CalendarValidation()}>
                                                            <Calendar
                                                                disabled={true}
                                                                placeholder="Date Range"
                                                                selectionMode="multiple"
                                                                className="w-full h-11" /> </div>

                                                        :
                                                        <Calendar
                                                            onChange={(e) => {
                                                                setPeriodDates(null);
																setSelectedDateRecord([]);
																setAbsentDate([])
                                                                //setPeriodDates(e.value)
                                                                const nextMinDate = new Date(e.value);
																let dayNumber = nextMinDate.getDay()
                                                                //const nextMaxDate = new Date(e.value);
																let nextMaxDate = nextMinDate;
																nextMinDate.setDate(nextMinDate.getDate() - (dayNumber - 1));
																let from = new Date(moment(nextMinDate).format("YYYY-MM-DD"));
																nextMaxDate.setDate(nextMinDate.getDate() + 4);
																let to = new Date(moment(nextMaxDate).format("YYYY-MM-DD"));
																let dateArray = [from, to];
																setPeriodDates(dateArray)
                                                                //nextMaxDate.setDate(nextMinDate.getDate() + 4);
                                                                //setMinDate(nextMinDate);
                                                                //setMaxDate(nextMaxDate);
                                                            }}
                                                            value={periodDates}
                                                            minDate={minDate}
                                                            maxDate={maxDate}
                                                            disabled={disabled}
                                                            placeholder="Date Range"
                                                            selectionMode="range"
                                                            className="w-full h-11" />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/*-----Period----*/}
                                </div>
                            </div>

                            <div className="mt-5 xl:mt-[1.094vw] pb-10 ">
                                <div className="grid grid-cols-2 lg:grid-cols-12 gap-6 xl:gap-[1.250vw]">
                                    <div className="col-span-12 lg:col-span-8">
                                        <div id={SelectperiodExpand} className="box-shadow-1 bg-white">
                                            <div className="flex justify-between items-center p-4 xl:p-[0.833vw]">
                                                <div className="text-[#101828] font-semibold -tracking-[0.02em] text-base xl:text-[0.833vw]"><p>Select Period</p></div>
                                                <div className=""><Button href={'/'} onClick={toggleActiveexpand} style={{ background: '#ffffff00', border: '0', padding: '0', width: '24px', height: '24px' }}><i className="gusd-expand text-base text-[#101828]"></i></Button></div>
                                            </div>
                                            <div className="custmCalendar p-4 xl:p-[0.833vw]">
                                                <Calendar value={absentDate} onChange={(e) => {
                                                    if (reportId) { if (selectedEmployee === null) { toast.error("Please Select Employee"); return; } else { onClickDates(e.value); setAbsentDate(e.value); } } else { onClickDates(e.value); setAbsentDate(e.value); }
                                                }}
                                                    minDate={new Date(moment(periodDates[0]).format("YYYY,M,DD"))}
                                                    maxDate={new Date(moment(periodDates[1]).format("YYYY,M,DD"))}
                                                    inline
                                                    disabledDates={disabledDates}
                                                    selectionMode="multiple" />
                                            </div>
                                        </div>

                                        {/*---Preview Section---*/}
                                        <div className="mt-6 xl:mt-[1.250vw]">
                                            <div className="bg-white box-shadow-1">
                                                <div className="p-4 xl:p-[0.833vw] pb-0">
                                                    <div className="text-[#101828] font-semibold -tracking-[0.02em] text-base xl:text-[0.833vw]">
                                                        <p>Preview</p></div></div>
                                                <div className="px-3 xl:px-[0.677vw] custp-table-d initiatorperiodtable">
                                                    {
                                                        visible &&
                                                        <Paper>
                                                            <Table>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell>Name of Employee</TableCell>
                                                                        <TableCell>
                                                                            Dates Absent</TableCell>
                                                                        <TableCell>Absent Codes</TableCell>
                                                                        <TableCell>Total Hours</TableCell>
                                                                        <TableCell>Name of Substitute</TableCell>
                                                                        <TableCell>Action</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>

                                                                    {mappedData.map((item, i) => (

                                                                        <Fragment>
                                                                            <TableRow>
                                                                                <TableCell
                                                                                    rowSpan={item.employeeResponse.length + 1}
                                                                                >
                                                                                    {item.employeeName}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                            {item.employeeResponse.map((detail, detailIndex) => (

                                                                                <TableRow>
                                                                                    <TableCell>{moment(detail.selectedDate, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)").format("MM/DD/YYYY")}</TableCell>
                                                                                    <TableCell>{detail.absentCode.name}</TableCell>
                                                                                    <TableCell>
                                                                                        {detail.hour === null + ":" && Number(detail.minute / 60 * 100).toFixed(0) + " hr" === null ? "-" : detail.hour + ":" !== null && Number(detail.minute / 60 * 100).toFixed(0) === null ? detail.hour : detail.hour + ":" === null && Number(detail.minute / 60 * 100).toFixed(0) + " hr" !== null ? Number(detail.minute / 60 * 100).toFixed(0) + "min" : detail.hour + ":" + Number(detail.minute / 60 * 100).toFixed(0) + " hr"}</TableCell>
                                                                                    <TableCell>{detail.nameOfTheSubstitute.name}</TableCell>
                                                                                    <TableCell><Link className='pi pi-trash ml-3  ' onClick={() => {
                                                                                        onClickRemove(i, detailIndex, detail)
                                                                                    }}></Link></TableCell>
                                                                                </TableRow>
                                                                            ))}
                                                                        </Fragment>
                                                                    ))}
                                                                </TableBody>
                                                            </Table>
                                                        </Paper>
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                        {/*---Preview Section---*/}
                                        <div className="mt-[1.250vw]">
                                            <div className="flex flex-wrap justify-between items-center">
                                                <div className="">
                                                    <Link to={"/approver/weekly_absence_report"} className="text-[#344054] text-xs xl:text-[0.938vw] font-medium bg-white inline-block border border-[#D0D5DD] rounded xl:rounded-lg py-[0.833vw] px-[2.917vw] box-shadow-2">Back</Link></div>
                                                {
                                                    visible &&
                                                    <div className="space-x-4">
                                                        <Link onClick={() => saveReport(Request_Status.O)} className="font-medium inline-block text-[#667085] text-xs xl:text-[0.938vw] py-[0.833vw] px-[2.448vw]"><i className="pi pi-save mr-1" style={{ fontSize: '1rem' }}></i>Save</Link>
                                                        <Link onClick={() => {
                                                            setVisibleDialogue(true)
                                                        }} className="font-medium inline-block text-[#FFFFFF] text-xs xl:text-[0.938vw] py-[0.833vw] px-[2.448vw] box-shadow-2 rounded xl:rounded-lg bg-[#113699] border border-[#F2F4F7]">Submit</Link>
                                                    </div>
                                                }

                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-span-12 lg:col-span-4">
                                        <div className="bg-white box-shadow-1 p-4 rounded-lg xl:p-[0.833vw]">
                                            <div className="text-[#101828] font-semibold text-base xl:text-[0.833vw]"><p>Selected Dates</p></div>
                                            {
                                                isShowSelectedDate &&
                                                selectedDateRecord.map((currentItem, i) => {
                                                    return (
                                                        <div key={i}>
                                                            <div className="mt-[24px] xl:mt-[1.250vw]">
                                                                <div className="text-[#344054] font-normal text-xs xl:text-[0.625vw] flex flex-wrap items-center justify-between lg:flex-nowrap"><p className="w-full lg:w-[7.813vw] text-[11px] font-bold">{moment(currentItem.displayDate).format("D MMMM YYYY")}</p><span className="w-full h-[1px] bg-[#E4E7EC] inline-block"></span></div>
                                                            </div>
                                                            <div className="mt-[16px] xl:mt-[0.833vw]">
                                                                <div className="bg-[#F2F4F7] rounded p-2 xl:p-[0.417vw] custseledate">
                                                                    <div className="w-full">
                                                                        <label htmlFor="username" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Absent Code <span className='text-[red] pl-0.2'>*</span></label>
                                                                        <Dropdown
                                                                            filter
                                                                            value={currentItem.absentCode} onChange={(e) => { onClickAbsentCode(i, e) }} options={absentCodeListDropdown} optionLabel="name" placeholder="Select an Absent Code" className="w-full h-7 absent" />
                                                                    </div>

                                                                    <div className="w-full">
                                                                        <label htmlFor="username" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Name of the Substitute </label>
                                                                        <Dropdown
                                                                            filter
                                                                            value={currentItem.nameOfTheSubstitute} onChange={(e) => onClickNameOfSubstitute(i, e)} options={updatedEmpList} optionLabel="name" placeholder="Select a Substitute" className="w-full h-7" />
                                                                    </div>

                                                                    <div className="p-[8px] mt-[8px] xl:mt-[0.417vw] xl:p-[0.417vw]">
                                                                        <div className="flex flex-wrap gap-3">
                                                                            {
                                                                                <div className="">
                                                                                    <label htmlFor="username" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Total Hours<span className='text-[red] '>*</span></label>
                                                                                    <div className="flex">
                                                                                        <div className="relative custinput-h">
                                                                                            <div className="bg-[#F2F4F7] flex items-center justify-center absolute right-[0rem] top-[0.1rem] text-[0.75rem] font-normal text-[#818C95] w-[1.563rem] h-[1.35rem] border border-[#E4E7EC]"><p>H</p></div>
                                                                                            <InputNumber inputId="integeronly" value={currentItem.hour}
                                                                                                maxLength={2} max="24"
                                                                                                onValueChange={(e) => { onClickHoure(i, e.target.value) }} className="bg-[#ffffff00] h-[1.35rem]" />
                                                                                        </div>

                                                                                        <div className="relative custinput-m">
                                                                                            <div className="bg-[#F2F4F7] flex items-center justify-center absolute right-[0rem] top-[0.1rem] text-[0.75rem] font-normal text-[#818C95] w-[1.563rem] h-[1.35rem] border border-[#E4E7EC] rounded-br-[5px] rounded-tr-[5px]"><p>M</p></div>
                                                                                            <InputNumber value={currentItem.minute}
                                                                                                maxLength={2} max="59"
                                                                                                onValueChange={(e) => { onClickMin(i, e.target.value) }} className="bg-[#ffffff00] h-[1.35rem]" />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                            {
                                                selectedDateRecord >= 0 ? null : <div className="custbutn mt-6 xl:mt-[1.250vw]">
                                                    <Button className="" label={showPleaseWaitButton ? 'Please wait...' : 'Apply'} onClick={() => {
                                                        applyReport()
                                                    }}>
                                                    </Button>
                                                </div>

                                            }



                                        </div>

                                        <div className="bg-white box-shadow-1 p-4 mt-6 rounded-lg xl:p-[0.833vw] xl:mt-[1.250vw]">
                                            <div className="text-[#101828] font-semibold text-base xl:text-[0.833vw]"><p>Absence Codes - Legends</p></div>
                                            <div className="flex flex-wrap xl:flex-nowrap gap-4 mt-5 xl:gap-[0.938vw] xl:mt-[1.250vw]">


                                                <div className="text-[#344054] font-semibold text-xs xl:text-[0.729vw] space-y-1">
                                                    {absentCodeList.length > 0 && absentCodeList.slice(0, 7).map((item, index) => {
                                                        return (<>
                                                            <p>{item.code} - <span className="font-normal">{item.name}</span></p>
                                                        </>
                                                        )
                                                    })}
                                                </div>

                                                <div className="text-[#344054] font-semibold text-xs xl:text-[0.729vw] space-y-1">
                                                    {absentCodeList.length > 0 && absentCodeList.slice(7, 14).map((item, index) => {
                                                        return (<>
                                                            <p>{item.code} - <span className="font-normal">{item.name}</span></p>
                                                        </>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="dialogpoput flex justify-content-center ">
                                        <Dialog visible={visibleDialogue} position="center" style={{ width: '30vw' }} className="dialogpoput dialogres submit_popup" onHide={() => setVisibleSumbit(false)}>

                                            <div className="text-[#101828] text-lg py-2 pt-5 font-bold text-center">Submit Report</div>
                                            <div className="text-[#344054] text-xs pb-2 font-medium">Your report will be sent for review, you will be notified of updates.</div>

                                            <div className="pt-2 flex pb-[-2px] justify-center gap-2">
                                                <Link href={''} className="custmBtn3 rounded-lg text-[black] text-center bg-[White]" onClick={() => {
                                                    setVisibleDialogue(false)
                                                }}
                                                > Cancel
                                                </Link>
                                                <Link href={''} className="custmBtn3 rounded-lg text-[#FFFFFF] text-center bg-[#113699]" onClick={() => {
                                                    setVisibleDialogue(false)
                                                    saveReport(Request_Status.S)
                                                    // submitReport()
                                                }}
                                                >Send
                                                </Link>
                                            </div>

                                        </Dialog>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </Layout>
        </>

    ) : (
        <Login sessionExpired={1} />
    );
}